class SelectImg {
    constructor(el, opt) {
      this.el = el;
      // if($(this.el).length){
      // }
      this.event();
    }
    event(){
      $(function() {

        if($(".error").length || $(".mw_wp_form_confirm").length) {
          for(let i = 1; i < 4; i++) {
            if($.cookie(`input-group0${i}`)) {
              $(`#input-group0${i} .send-text`).text($.cookie(`input-group0${i}`));
            }
          }
        }

        const files = document.querySelectorAll('.send-img')
        const imgTll = document.querySelectorAll('.send-text')
        const btn = document.querySelector(".submitBtn")

        // var date = new Date();
        // date.setTime( date.getTime() + ( 5 * 1000 ));

        files.forEach((file, index) => {

          $(file).on('change', function () { //ファイルが選択されたら
            let file = $(this).prop('files')[0]; //ファイルの情報を代入(file.name=ファイル名/file.size=ファイルサイズ/file.type=ファイルタイプ)
            $(this).parent().next().text(file.name);

            $.cookie($(this).parent().parent().attr("id"), file.name);
          });
        });

        if($(".submitBtn[value='send']").length) {
          $(".submitBtn[value='send']").click(function() {
            for(var i = 1; i < 4; i++) {
              if($.cookie(`input-group0${i}`)) {
                $.removeCookie(`input-group0${i}`);
              }
            }
          })
        }
      });
    }
  }